<div
  class="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[calc(100%-2rem)] max-w-sm flex-col gap-2"
  aria-live="assertive"
  aria-atomic="false"
>
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="pointer-events-auto flex items-start gap-3 rounded-lg border border-border bg-surface px-4 py-3 shadow-flyout"
      [attr.role]="toast.kind === 'error' ? 'alert' : 'status'"
      (mouseenter)="toastService.hold(toast.id)"
      (mouseleave)="toastService.release(toast.id)"
    >
      <span class="mt-0.5 shrink-0" [class]="styles[toast.kind].accent">
        <pp-icon [name]="styles[toast.kind].icon" [size]="18"></pp-icon>
      </span>

      <div class="min-w-0 flex-1">
        <p class="text-[13px] font-semibold text-ink-primary">{{ toast.title }}</p>
        @if (toast.message) {
          <p class="mt-0.5 text-[13px] text-ink-secondary break-words">{{ toast.message }}</p>
        }
        @if (toast.details?.length) {
          <ul class="mt-1 list-disc pl-4 text-[12px] text-ink-secondary">
            @for (detail of toast.details; track $index) {
              <li class="break-words">{{ detail }}</li>
            }
          </ul>
        }
      </div>

      <button
        type="button"
        (click)="toastService.dismiss(toast.id)"
        class="shrink-0 text-ink-muted transition-colors hover:text-ink-secondary"
        aria-label="Dismiss"
      >
        <pp-icon name="x" [size]="16"></pp-icon>
      </button>
    </div>
  }
</div>
